module.exports = __webpack_public_path__ + "static/media/Group 3.cfc21766.png";